import { api } from '../../../lib/api'

export const GET_PRODUCT_REQUEST = 'GET_PRODUCT_REQUEST'
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS'
export const GET_PRODUCT_FAILED = 'GET_PRODUCT_FAILED'

export const getProduct = function (productId) {
  return function (dispatch) {
    dispatch({
      type: GET_PRODUCT_REQUEST
    })
    api.getProduct(productId).then(getProductResponse => {
      dispatch({
        type: GET_PRODUCT_SUCCESS,
        payload: getProductResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_PRODUCT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/get-product.js